import { createContext } from "react";

import type { PermissionContextType } from "./type";

export const permissionContext = createContext<PermissionContextType>({
  permission: {},
  notFoundPath: "/404",
});
